import React from 'react'

const HeartOutline = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.132 12.51l-.003.003-7.13 6.562-7.1-6.537-.036-.033a3.971 3.971 0 01.023-5.7 4.207 4.207 0 012.947-1.186c1.102 0 2.14.413 2.92 1.158l.06.064c.314.309.74.482 1.187.482h.006a1.692 1.692 0 001.189-.49l.054-.056a4.198 4.198 0 012.917-1.158 4.21 4.21 0 012.948 1.185 3.972 3.972 0 01.018 5.707m1.16-6.851A5.906 5.906 0 0016.166 4a5.904 5.904 0 00-4.125 1.66L12 5.704l-.041-.044A5.906 5.906 0 007.833 4a5.904 5.904 0 00-4.125 1.66 5.555 5.555 0 000 8.014l.018.014v.001l7.701 7.09.003-.004a.837.837 0 001.14 0l.003.003 7.701-7.089.018-.015a5.555 5.555 0 000-8.014"
      fill={props.fill}
    />
  </svg>
)

export default HeartOutline
